import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICellEditorAngularComp, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'checkbox-cell-editor',
  template: `<input type="checkbox" [(ngModel)]="value" (click)="checkedHandler($event)" [checked]="value">`,
  styles: [':host{margin-left:11px}'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
  ],
})
export class PxdAgGridCheckboxRenderer implements ICellEditorAngularComp {

  private params: any;
  public value: any;
  public agInit(params: any): void {
    this.params = params;
    if (params && params.value !== undefined && params.value !== null) {
      this.value = params.value;
    }
  }

  public checkedHandler(e) {
    let checked = e.target.checked;
    let colId = this.params.column.colId;
    this.params.node.setDataValue(colId, checked);
  }

  public getValue() {
    return this.value;
  }
}

@Component({
  selector: 'checkbox-cell',
  template: `<input type="checkbox" [checked]="params.value" disabled="disabled">`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class PxdAgGridCheckboxRendererReadOnly implements ICellRendererAngularComp {

  public params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}